import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { GridIcon, NetworkIcon, PinIcon, ShieldIcon } from './icons'

const soon = [
  { label: 'Overview', Icon: GridIcon },
  { label: 'Network', Icon: NetworkIcon },
  { label: 'Admin', Icon: ShieldIcon },
]

export function PorcelainShell({ children }: { children: ReactNode }) {
  return (
    <div
      className="flex h-full bg-[var(--color-bg)] text-[var(--color-fg)]"
      style={{ fontFamily: 'var(--v1-font-sans)' }}
    >
      <aside
        className="flex w-[232px] shrink-0 flex-col gap-1 border-r border-[var(--color-border)] px-3 py-5 backdrop-blur-[20px]"
        style={{ background: 'var(--v1-sidebar-bg)' }}
      >
        <div className="mb-5 flex items-center gap-2.5 px-2">
          <span
            className="grid size-8 place-items-center rounded-[10px] text-[15px] font-semibold"
            style={{ background: 'var(--color-accent)', color: 'var(--color-accent-fg)' }}
          >
            S
          </span>
          <span className="text-[15px] font-semibold tracking-[-0.01em]">Sync</span>
        </div>

        <nav className="flex flex-col gap-0.5" aria-label="Primary">
          <Link
            to="/locations"
            className="flex h-9 items-center gap-2.5 rounded-[10px] px-2.5 text-[14px] font-medium text-[var(--color-fg)] transition-colors hover:bg-[var(--color-surface-2)] focus-visible:outline-2 focus-visible:outline-[var(--color-accent)]"
            activeProps={{
              className: '!bg-[var(--color-accent)] !text-[var(--color-accent-fg)] hover:!bg-[var(--color-accent)]',
              'aria-current': 'page',
            }}
          >
            <PinIcon />
            Locations
          </Link>
          {soon.map(({ label, Icon }) => (
            <span
              key={label}
              aria-disabled="true"
              className="flex h-9 cursor-default items-center gap-2.5 rounded-[10px] px-2.5 text-[14px] font-medium text-[var(--color-muted)] opacity-60"
            >
              <Icon />
              {label}
            </span>
          ))}
        </nav>

        <p className="mt-auto px-2.5 text-[12px] text-[var(--color-muted)]">Porcelain</p>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header
          className="flex h-12 shrink-0 items-center border-b border-[var(--color-border)] px-8 text-[13px] text-[var(--color-muted)] backdrop-blur-[20px]"
          style={{ background: 'var(--v1-header-bg)' }}
        >
          <span>DTLR</span>
          <span className="mx-2 opacity-50">/</span>
          <span className="text-[var(--color-fg)]">Locations</span>
        </header>
        <main className="min-h-0 flex-1 overflow-auto">
          <div className="mx-auto w-full max-w-[1040px] px-8 py-10">{children}</div>
        </main>
      </div>
    </div>
  )
}
